import { render } from "./Advanced.vue?vue&type=template&id=3aa08c2e&scoped=true&ts=true"
import script from "./Advanced.vue?vue&type=script&lang=ts"
export * from "./Advanced.vue?vue&type=script&lang=ts"

import "./Advanced.vue?vue&type=style&index=0&id=3aa08c2e&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa08c2e"]])

export default __exports__